class CustomNewsletter extends HTMLElement {
  constructor() {
  super();

    this.submitBtn = this.querySelector('form button');
    this.tempBtn = this.querySelector('.newsletter__form--tempBtn');

    if (this.submitBtn && this.submitBtn.hasAttribute('disabled')) {
      this.submitBtn.classList.add('hidden');
      this.tempBtn?.classList.remove('hidden');

      setTimeout(() => {
        document.documentElement.removeAttribute('scroll-lock');
      }, 300);

      setTimeout(() => {
        this.submitBtn?.classList.remove('hidden');
        this.tempBtn?.classList.add('hidden');
        this.submitBtn?.removeAttribute('disabled');
      }, 10000);
    }
  }
}

customElements.define('custom-newsletter', CustomNewsletter);